// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useEffect, useState} from 'react';
import cn from 'classnames';
import {Link} from 'react-router-dom';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Icon_globe from '../../img/icons/24/globe.svg';
import Icon_lightning from '../../img/icons/24/lightning.svg';
import Icon_check_circle from '../../img/icons/24/check_circle.svg';
import Icon_stopwatch from '../../img/icons/24/stopwatch.svg';
import Icon_dashboard from '../../img/icons/24/dashboard.svg';
import Icon_checkbox_multiple from '../../img/icons/24/checkbox_multiple.svg';
import styles from './why_oculus.module.less';
import {Input} from '../../../../hola/pub/lib/input';
import {Button} from '../../lib/button';
import {Dynamic_heading, Title_header_select} from '../../../../shared/editor/title_header_select';

interface i_why_oculus_card {
    icon: JSX.Element;
    title: string;
    text: string;
    href?: string;
}

const cards: i_why_oculus_card[] = [
    {
        icon: <Icon_lightning />,
        title: 'Quick & Free Setup',
        text:
            'No KYC needed our proxies offer super fast connection speed '
            +'for your needs.',
    },
    {
        icon: <Icon_check_circle />,
        title: 'Zero downtime',
        text: 'Our monthly proxies never have down time and we heavily '
            +'monitor all of our servers to ensure quality.',
    },
    {
        icon: <Icon_stopwatch />,
        title: 'Fast performance',
        text: 'You can always depend on our proxies to perform during heavy '
            +'traffic releases on our 100GBPS dedicated servers.',
    },
    {
        icon: <Icon_globe />,
        title: 'Location',
        href: '/proxy-location',
        text: 'Hundreds of proxies from 195 countries at your fingertips',
    },
    {
        icon: <Icon_dashboard />,
        title: 'Simple dashboard',
        text: 'Easily track and manage your GB usage and your remaining time '
            +'of expiration.',
    },
    {
        icon: <Icon_checkbox_multiple />,
        title: 'Free Proxy Tester Tool',
        text: 'Test your proxy list right from your dashboard and get '
            +'instant results.',
    },
];

interface I_why_oculus_props {
    title?: string;
    title_tag?: string;
}
interface i_product_editor_props {
  value: I_why_oculus_props;
  on_change: (v:I_why_oculus_props)=>void;
  on_cancel: ()=>void;
}

export const Why_oculus_editor = (props:i_product_editor_props)=>{
  const [state, set_state] = useState<I_why_oculus_props>(props.value || {});
  useEffect(()=>{
      set_state(props.value);
  }, [props.value]);
  return <div>
    <Input size={'sm'} label={'title (html)'} value={state.title || ''}
      on_change={v=>set_state({...state, title: v})}/>
    <Title_header_select value={state.title_tag} on_select={v=>
      set_state({...state, title_tag: v})}/>
    <br/>
    <Button caption={'Save'} size={'s'}
      on_click={()=>props.on_change(state)}/>
    <Button caption={'Cancel'} size={'s'} on_click={()=>props.on_cancel()}/>
  </div>;
};

export const Why_oculus = (props: I_why_oculus_props)=>{
    const {theme} = useContext(Settings_context);
    return <section className={styles.why_oculus}>
      <Dynamic_heading dangerouslySetInnerHTML={{
        __html: props.title || 'Why Oculus?'}} tag={props.title_tag}/>
      <div className={styles.cards_grid}>
      {cards.map((card, index)=>{
        const cardContent = <>
          <div className={styles.img}>{card.icon}</div>
          <div className={styles.text}>
            <p className={cn(theme.p18, theme.bold, styles.title)}>
              {card.title}</p>
            <p className={cn(theme.p14, theme.med)}>{card.text}</p>
          </div>
        </>;
        return card?.href ? <Link
          key={index}
          to={card.href}
          className={cn(styles.card, styles.card_link)}>
          {cardContent}
        </Link> : <div key={index} className={styles.card}>
          {cardContent}
        </div>;
      })}
      </div>
    </section>;
};
